import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();
export default class FormTemplateAPI {

    URI_V1 = "/v1/form-templates"

    createNewForm = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/save`, data);
    };

    createNewFormMultipart = async (formData: any) => {
        return await apiService.postFormData(`${this.URI_V1}/save`, formData);
    };
    
    list = async (companyId: any) => {
        return await apiService.get(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getById = async (formId: any, companyId: any) => {
        return await apiService.get(`${this.URI_V1}/${formId}?companyId=${companyId}`);
    };

    updateStatus = async (formId: any, newStatus: any) => {
        return await apiService.patch(`${this.URI_V1}/${formId}/update-status?newStatus=${newStatus}`, {});
    };

    delete = async (formId: any) => {
        return await apiService.delete(`${this.URI_V1}/${formId}`);
    };

}
